/**
 * Shared local book catalog — the hardcoded seed/discoverable books (see
 * components/bookshelf/constants/seedBooks.js) plus lookup helpers over
 * them. Originally lived only in components/coverClub/utils/bookCatalog.js;
 * promoted here so Book Details can resolve the same ids without importing
 * through the Cover Club feature slice. Cover Club's own bookCatalog.js
 * re-exports getBookById/isBookOnShelf from here so its existing imports
 * keep working unchanged.
 */

import { SEED_BOOKS, DISCOVERABLE_BOOKS } from '@/components/bookshelf/constants/seedBooks';

const CATALOG = [...SEED_BOOKS, ...DISCOVERABLE_BOOKS];
const CATALOG_BY_ID = new Map(CATALOG.map((book) => [book.id, book]));

export function getBookById(bookId) {
  return CATALOG_BY_ID.get(bookId) ?? null;
}

export function isBookOnShelf(bookId, shelfBooks) {
  return shelfBooks.some((b) => b.id === bookId);
}

/**
 * The full local catalog, for subject/genre-overlap "similar books" scoring.
 */
export function getAllCatalogBooks() {
  return CATALOG;
}
